import type { ActualizationStateType } from './types';

import { metaPoliciesDTO } from './metaPoliciesDTO';
import { packageDTO } from '../package/packageDTO';
import { miscDataDTO } from '../package/miscDataDTO';
import { flightOptionsDTO } from './flightOptionsDTO';
import { actualizationChangesDTO } from './actualizationChangesDTO';

export const actualizationDTO = (
  data: unknown,
): Omit<
  ActualizationStateType,
  | 'fetching'
  | 'lastUpdated'
  | 'error'
  | 'showPriceChanged'
  | 'isActualizationProcess'
  | 'frontError'
  | 'hotelFacts'
> => {
  if (data && typeof data === 'object') {
    return {
      cache_level:
        'cache_level' in data && typeof data.cache_level === 'number'
          ? data.cache_level
          : null,
      changes: 'changes' in data ? actualizationChangesDTO(data.changes) : {},
      exception:
        'exception' in data && typeof data.exception === 'string'
          ? data.exception
          : null,
      exclude_operator:
        'exclude_operator' in data && typeof data.exclude_operator === 'boolean'
          ? data.exclude_operator
          : null,
      flight_options:
        'flight_options' in data ? flightOptionsDTO(data.flight_options) : [],
      meta_policies:
        'meta_policies' in data ? metaPoliciesDTO(data.meta_policies) : null,
      package: 'package' in data ? packageDTO(data.package) : {},
      prebook_data:
        'prebook_data' in data ? miscDataDTO(data.prebook_data) || {} : {},
      rotten:
        'rotten' in data && typeof data.rotten === 'boolean'
          ? data.rotten
          : false,
      show_modal_customer:
        'show_modal_customer' in data &&
        typeof data.show_modal_customer === 'boolean'
          ? data.show_modal_customer
          : false,
      success:
        'success' in data && typeof data.success === 'boolean'
          ? data.success
          : false,
      ordered:
        'ordered' in data && typeof data.ordered === 'boolean'
          ? data.ordered
          : false,
    };
  }

  return {
    success: null,
    rotten: false,
    exception: null,
    show_modal_customer: false,
    changes: {},
    prebook_data: {},
    cache_level: null,
    exclude_operator: null,
    flight_options: null,
    meta_policies: null,
    package: {},
    ordered: false,
  };
};
